<template>
  <div class="action-bar">
    <Button
      label="Print Label"
      @click="generatePDF"
    />
  </div>

  <div
    ref="labelContent"
    class="label-container"
  >
    <div class="label-content">
      <!-- QR Code on the left -->
      <div class="qr-section">
        <img
          src="/images/qrCode.png"
          alt="Part QR Code"
          class="qr-code"
        >
      </div>
            
      <!-- Part Name on the right -->
      <div class="part-name">
        <span>{{ partName }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const labelContent = ref(null);

// Sample data - in real app this would come from props or store
const partName = ref('Sample Part');

const generatePDF = async () => {
    const content = labelContent.value;
    const canvas = await html2canvas(content);
    const imgData = canvas.toDataURL('image/png');
    // Use label dimensions (75mm x 25mm)
    const pdf = new jsPDF('p', 'mm', [75, 25]);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('part-label.pdf');
};
</script>

<style scoped>
.action-bar {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}

.label-container {
    width: 75mm;
    height: 25mm;
    margin: 0 auto;
    padding: 2mm;
    font-family: Arial, sans-serif;
    color: #333;
    background-color: white;
    border: 1px solid #e0e0e0;
}

.label-content {
    display: flex;
    align-items: center;
    height: 100%;
}

.qr-section {
    flex: 0 0 20mm;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.qr-code {
    width: 20mm;
    height: 20mm;
    object-fit: contain;
    margin: auto;
}

.part-name {
    flex: 1;
    padding-left: 2mm;
    font-size: 12pt;
    font-weight: bold;
    word-break: break-word;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
    overflow: hidden;
}

.part-name span {
    width: 100%;
    text-align: center;
    transform-origin: center;
    transform: scale(1);
    white-space: normal;
    line-height: 1.2;
}
</style>